// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export enum DealTypeInputFields {
    isNew = 'isNew',
    isBuy = 'isBuy',
    isCash = 'isCash',
    isTradeIn = 'isTradeIn',
    isLeaseTurnIn = 'isLeaseTurnIn',
}

export type DealTypeInputs = Record<DealTypeInputFields, boolean>;

export const DealTypeLabels: Record<DealTypeInputFields, string[]> = {
    isNew: ['New', 'Used'],
    isBuy: ['Buy', 'Lease'],
    isCash: ['Cash', 'Finance'],
    isTradeIn: ['Trade-In', 'No Trade-In'],
    isLeaseTurnIn: ['Lease Turn-In', 'No Lease Turn-In'],
};

export enum CustomerFormFields {
    firstName = 'firstName',
    lastName = 'lastName',
    email = 'email',
    phone = 'phone',
}

export interface CustomerFormGroup {
    firstName: string;
    lastName: string;
    middleName?: string;
    email: string;
    phone: string;
    logonId: string;
    enableMfa?: boolean;
}

export interface ProfileFormGroup {
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    phone: string;
    logonId: string;
}

export interface CustomerFormField {
    disabled: boolean;
    name: CustomerFormFields;
    value: string;
}

export enum CreateDealSteps {
    dealType,
    details,
    summary,
}

export interface DealerFormGroup {
    dealerDealNumber: string;
}

export interface ManualAddVehicleFormGroup {
    mVin: string;
    mStockNumber: string;
    mPrice: number;
    mYear: number;
    mModel: string;
    mMake: string;
    mTrim: string;
    mBodyStyle: string;
    mInteriorColor: string;
    mExteriorColor: string;
    mBodyType: string;
    mStatus: string;
}
